import {
    useQueryParam,
    NumberParam,
    StringParam,
    withDefault,
} from 'use-query-params';
import {TIME_TRIAL_ALL_LEVELS} from '@utils/const/const';

export const useTimeTrialLeaderboardQueryParams = () => {
    const [tab, setTab] = useQueryParam(
        'tab',
        withDefault(StringParam, 'global')
    );
    const [dateRange, setDateRange] = useQueryParam(
        'date_range',
        withDefault(StringParam, 'all_time')
    );
    const [level, setLevel] = useQueryParam(
        'level',
        withDefault(NumberParam, TIME_TRIAL_ALL_LEVELS)
    );
    const [sort, setSort] = useQueryParam('sort', StringParam);

    return {
        tab,
        dateRange,
        level,
        sort,
        setTab,
        setDateRange,
        setLevel,
        setSort,
    };
};
